export default {
  SECURITY_QUESTION_MAX_RETRIES: 'security-question-max-retries',
  SECURITY_QUESTION_ANSWER_INVALID: 'security-question-answer-invalid',
};
